/**
 * @name showProductsDiscount
 * @description
 * Show logo of campaign associated to collection
 */
export default function _showProductsDiscount() {

    // Get Diff betweent two values
    const getPercentageChange = (oldNumber, newNumber) => {
        var decreaseValue = oldNumber - newNumber;
        return (decreaseValue / oldNumber) * 100;
    }

    const positionDiscount = (sticker, discount) => {
        if (sticker && discount) {
            if (document.querySelector('.snize-list-mode-icon.active')) {
                const newWidthDiscount = sticker.offsetWidth;
                discount.style.left = `${newWidthDiscount}px`;
                discount.style.top = '-10px';
            } else {
                const newHeightDiscount = sticker.offsetHeight - 10;
                const exclusiveLabel = discount.parentElement.querySelector("span.snize-overhidden div[class='snize-product-label top-left']");
                if (exclusiveLabel) {
                    exclusiveLabel.style.top = `${newHeightDiscount}px`;
                    discount.style.top = `${newHeightDiscount + 23}px`;
                } else {
                    discount.style.top = `${newHeightDiscount}px`;
                }
                discount.style.left = 0;
            }
        } else if (discount) {
            if (!document.querySelector('.snize-list-mode-icon.active')) {
                if (discount.parentElement.querySelector(".snize-product-label.top-right")) {
                    discount.style.top = '3px';
                    discount.style.left = 0;
                } else if (discount.parentElement.querySelector(".snize-product-label.top-left")) {
                    discount.style.top = '26px';
                    discount.style.left = 0;
                }
            }
        }
    }

    // Get all products
    const els = document.getElementsByClassName("snize-product");
    Array.prototype.forEach.call(els, function (el) {
        /**
         * Bug fixed for products without data but if contains DOM
         */
        if (!el || el.classList.length === 1) return;

        if (el.classList.contains('snize-product-tag-pvpr_price')) return;

        const stickerExists = el.querySelector('#campaign-stickers');

        if(el.querySelector('#discount-percentaje')) {
            positionDiscount(stickerExists, el.querySelector('#discount-percentaje'));
            return;
        };

        const elPrice = el.querySelector('.snize-price');
        if(!elPrice.classList.contains('snize-price-with-discount')) return;

        const oldPrice = elPrice.getAttribute("data-old-price");
        const currentPrice = elPrice.innerHTML;
        const diff = Math.round(getPercentageChange(oldPrice, currentPrice));

        // Create the main container
        const discountContainer = document.createElement("div");
        discountContainer.id = "discount-percentaje";
        discountContainer.innerText = `-${diff}%`;
        
        if (diff > 5) {
            el.getElementsByClassName("snize-view-link")[0].appendChild(discountContainer);

            if (stickerExists) positionDiscount(stickerExists, discountContainer);
        }
  });
};